@import (reference) '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@header-height: 80px;

.header {
  padding: @space-16 @space-0;
  position: sticky;
  top: 0;
  background: inherit;
  align-items: center;
  gap: @space-24;
  height: @header-height;
}

.status {
  display: flex;
  gap: @space-12;
  align-items: center;
  color: var(--default--text-color--15);
  margin-top: @space-4;

  svg {
    width: 14px;
    height: 14px;
  }
}
